<template>
  <form-wrapper
    title="Checkboxes Settings"
    :hint-images="hint"
  >
    <background-color-settings
      :settings.sync="settings.background"
    />
    <v-flex xs6>
      <font-settings
        :settings.sync="settings.font"
        title="label:"
      />
    </v-flex>

    <reset-submit
      @submit="generateSubmit('checkbox')"
      @reset="resetSettings"
    />
  </form-wrapper>
</template>

<script>
  import BackgroundColorSettings from './../styleSettingsFormComponents/BackgroundColorSettings'
  import FontSettings from './../styleSettingsFormComponents/FontSettings'
  import FormWrapper from './FormWrapper'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'
  import {
    generateDefaultBackgroundParams,
    generateDefaultTextFonts,
    generateMapState
  } from './utils'

  export default {
    name: 'ButtonSettings',
    components: {
      BackgroundColorSettings,
      FontSettings,
      FormWrapper,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        settings: {
          background: generateDefaultBackgroundParams(),
          font: generateDefaultTextFonts()
        },
        hint: [
          {url: '/static/info/Checkboxes.png', title: 'Checkboxes' },
        ]
      }
    },
    computed: {
      ...generateMapState('checkbox')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/CheckboxesSettings.vue